const detectLocale = () => {
  if (typeof navigator === "undefined") return "es";
  const lang = (navigator.language || navigator.userLanguage || "es").toLowerCase();
  return lang.startsWith("es") ? "es" : "en";
};

export const locale = detectLocale();

const STRINGS = {
  es: {
    homeLink: "OverCut",
    homeAria: "Volver a OverCut",
    headerKicker: "OverCutGames",
    headerTitle: "OverCutDraft",
    dataLabel: "Datos",
    fallbackLabel: "Fallback",
    f1dbLabel: (year) => `f1db ${year}`,
    restart: "Reiniciar",
    play: "Jugar",
    calendarSource: (source) => `Calendario: ${source}`,
    calendarUnavailable: "Sin calendario disponible",
    statusBuild: "Construye una parrilla imposible",
    statusDraftTeams: "Draft de equipos",
    statusDraftDrivers: "Draft de pilotos",
    statusGridReady: "Parrilla lista",
    statusChampion: (name) => `Campeón ${name}`,
    statusRound: (round, name) => `Ronda ${round} · ${name}`,
    statusSeason: (year) => `Campeonato ${year}`,
    introTitle: "Draft histórico de F1 y campeonato simulado",
    teamsCounter: "Equipos",
    driversCounter: "Pilotos",
    racesCounter: "Carreras",
    scoringSystem: "Sistema de puntuación",
    scoringFastestLap: "VR",
    scoringBestResults: "MRE",
    raceTab: "Race",
    championshipTab: "Campeonato",
    rollTeam: "Tirar equipo",
    rollDriver: "Tirar piloto",
    rollAnotherDecade: "Otra decada",
    decadeKicker: "Decada",
    chosenKicker: "Elegido",
    drawnKicker: "Salio",
    assignTeamKicker: "Asigna equipo",
    pickDriverPrompt: "Elige piloto",
    introKicker: "Draft",
    introBrand: "OverCutDraft",
    pressPlay: "Pulsa jugar",
    readyToRoll: "Listo para tirar",
    assignSlotPrompt: "Pulsa un hueco libre en la parrilla para asignarlo a un equipo.",
    cancelAssignment: "Cancelar asignacion",
    autocomplete: "Autocompletar parrilla",
    ratingPrefix: (n) => `Rating ${n}`,
    ratingDetail: (firstYear, lastYear, rating) => `${firstYear}-${lastYear} · rating ${rating}`,
    seasonsDetail: (firstYear, lastYear, seasons) => `${firstYear}-${lastYear} · ${seasons} temporadas`,
    decadeDetail: (decade, firstYear, lastYear) => `${decade} · ${firstYear}-${lastYear}`,
    candidatesAvailable: (n) => `${n} pilotos disponibles`,
    availablePilots: "Pilotos disponibles",
    teamsList: "Equipos",
    pilotsList: "Pilotos",
    emptyTeams: "Sin equipos en parrilla",
    emptyDrivers: "Sin pilotos asignados",
    raceLoading: "Cargando calendario",
    raceButton: "Race",
    startFirstRace: "Empezar primera carrera",
    nextRace: "Siguiente carrera",
    viewFinalStandings: "Ver mundial final",
    continueNextRace: "Continuar a la siguiente carrera",
    viewChampion: "Ver campeón",
    season: "Temporada",
    champion: "Campeón",
    championCrowned: "Campeón del mundo",
    constructors: "Constructores",
    rounds: "Rondas",
    winners: "Ganadores",
    surprises: "Sorpresas",
    dnf: "DNF",
    simulating: "SIMULANDO...",
    round: (n) => `Ronda ${n}`,
    afterRound: (n) => `Tras la ronda ${n}`,
    winnerLabel: "Ganador",
    podiumLabel: "Podio de la carrera",
    positionLabel: (n) => `${n}. posicion`,
    top10: "Top 10",
    points: "Puntos",
    mundialAfter: (round) => `Mundial tras la ronda ${round}`,
    standingsDrivers: "Pilotos",
    finalStandings: "Clasificacion final",
    noRacesYet: "Aun no se han disputado carreras",
    emptyStandings: "Sin puntuacion todavia",
    assignHere: "Asignar aqui",
    pilotPlaceholder: "Piloto",
    teamPlaceholder: "Equipo",
    progressAria: "Progreso",
    scheduleTitle: "Calendario",
    gridBoardAria: "Parrilla OverCutDraft",
    weatherDry: "Seco",
    weatherMixed: "Mixto",
    weatherWet: "Lluvia",
    cleanPace: "Ritmo limpio",
    strategyEarlyInter: "Intermedia temprana",
    strategyUndercut: "Undercut",
    strategyTyreManagement: "Gestión de neumáticos",
    strategyTrackPosition: "Posición en pista",
    strategyPureRace: "Ritmo puro",
    tagDominant: "Dominio",
    tagUpset: "Sorpresa",
    tagWetMaster: "Lluvia",
    tagChaos: "Carrera rota",
    tagSafetyCar: "Coche de seguridad",
    tagLeaderDnf: "Golpe al líder",
    tagComeback: "Remontada",
    tagStreak: "Racha",
    tagPhotoFinish: "Foto finish",
    tagTeamDouble: "Doblete",
    tagStrategy: "Estrategia",
    tagControl: "Control",
    fallbackSourceCache: "OverCut f1db cache",
    fallbackSourceLocal: "Fallback local",
    dataSourceFallback: "Conjunto de datos local de respaldo",
  },
  en: {
    homeLink: "OverCut",
    homeAria: "Back to OverCut",
    headerKicker: "OverCutGames",
    headerTitle: "OverCutDraft",
    dataLabel: "Data",
    fallbackLabel: "Fallback",
    f1dbLabel: (year) => `f1db ${year}`,
    restart: "Restart",
    play: "Play",
    calendarSource: (source) => `Calendar: ${source}`,
    calendarUnavailable: "No calendar available",
    statusBuild: "Build an impossible grid",
    statusDraftTeams: "Constructors draft",
    statusDraftDrivers: "Drivers draft",
    statusGridReady: "Grid ready",
    statusChampion: (name) => `Champion ${name}`,
    statusRound: (round, name) => `Round ${round} · ${name}`,
    statusSeason: (year) => `${year} Championship`,
    introTitle: "Historic F1 draft and simulated championship",
    teamsCounter: "Teams",
    driversCounter: "Drivers",
    racesCounter: "Races",
    scoringSystem: "Scoring system",
    scoringFastestLap: "FL",
    scoringBestResults: "BRC",
    raceTab: "Race",
    championshipTab: "Championship",
    rollTeam: "Roll team",
    rollDriver: "Roll driver",
    rollAnotherDecade: "Another decade",
    decadeKicker: "Decade",
    chosenKicker: "Picked",
    drawnKicker: "Drawn",
    assignTeamKicker: "Assign team",
    pickDriverPrompt: "Pick driver",
    introKicker: "Draft",
    introBrand: "OverCutDraft",
    pressPlay: "Press play",
    readyToRoll: "Ready to roll",
    assignSlotPrompt: "Click an empty grid slot to assign this driver to a team.",
    cancelAssignment: "Cancel assignment",
    autocomplete: "Autofill grid",
    ratingPrefix: (n) => `Rating ${n}`,
    ratingDetail: (firstYear, lastYear, rating) => `${firstYear}-${lastYear} · rating ${rating}`,
    seasonsDetail: (firstYear, lastYear, seasons) => `${firstYear}-${lastYear} · ${seasons} seasons`,
    decadeDetail: (decade, firstYear, lastYear) => `${decade} · ${firstYear}-${lastYear}`,
    candidatesAvailable: (n) => `${n} drivers available`,
    availablePilots: "Available drivers",
    teamsList: "Teams",
    pilotsList: "Drivers",
    emptyTeams: "No teams on the grid",
    emptyDrivers: "No drivers assigned",
    raceLoading: "Loading calendar",
    raceButton: "Race",
    startFirstRace: "Start first race",
    nextRace: "Next race",
    viewFinalStandings: "View final standings",
    continueNextRace: "Continue to next race",
    viewChampion: "View champion",
    season: "Season",
    champion: "Champion",
    championCrowned: "World champion",
    constructors: "Constructors",
    rounds: "Rounds",
    winners: "Winners",
    surprises: "Surprises",
    dnf: "DNF",
    simulating: "SIMULATING...",
    round: (n) => `Round ${n}`,
    afterRound: (n) => `After round ${n}`,
    winnerLabel: "Winner",
    podiumLabel: "Race podium",
    positionLabel: (n) => `${n}${n === 2 ? "nd" : "rd"} place`,
    top10: "Top 10",
    points: "Points",
    mundialAfter: (round) => `Standings after round ${round}`,
    standingsDrivers: "Drivers",
    finalStandings: "Final standings",
    noRacesYet: "No races held yet",
    emptyStandings: "No points scored yet",
    assignHere: "Assign here",
    pilotPlaceholder: "Driver",
    teamPlaceholder: "Team",
    progressAria: "Progress",
    scheduleTitle: "Calendar",
    gridBoardAria: "OverCutDraft grid",
    weatherDry: "Dry",
    weatherMixed: "Mixed",
    weatherWet: "Rain",
    cleanPace: "Clean pace",
    strategyEarlyInter: "Early intermediates",
    strategyUndercut: "Undercut",
    strategyTyreManagement: "Tyre management",
    strategyTrackPosition: "Track position",
    strategyPureRace: "Pure pace",
    tagDominant: "Domination",
    tagUpset: "Upset",
    tagWetMaster: "Rain",
    tagChaos: "Race in pieces",
    tagSafetyCar: "Safety car",
    tagLeaderDnf: "Leader blow",
    tagComeback: "Comeback",
    tagStreak: "Streak",
    tagPhotoFinish: "Photo finish",
    tagTeamDouble: "1-2",
    tagStrategy: "Strategy",
    tagControl: "Control",
    fallbackSourceCache: "OverCut f1db cache",
    fallbackSourceLocal: "Local fallback",
    dataSourceFallback: "Local fallback dataset",
  },
};

export const strings = STRINGS[locale];
